import type { ResourceRef } from "../hooks/use-resource-query";

const ARTIFACT_RESOURCE_TYPE = "artifact";

export function artifactResource(artifactId: string): ResourceRef {
  return { type: ARTIFACT_RESOURCE_TYPE, id: artifactId };
}
